import {Redirect} from "react-router-dom";
import {CssBaseline} from "@mui/material";
import ManagerRoutes from "@/Containers/ManagerRoutes";
import {ConfirmProvider} from "material-ui-confirm";
import Sidebar from "@/Components/Sidebar/Sidebar";
import {useSelector} from "react-redux";
import {selectMandant} from "@/Redux/App/AppReducer";
import Sidebar70447 from "@/Components/Sidebar/Sidebar70447";
import SidebarV2 from "@/Components/Sidebar/SidebarV2/SidebarV2";

interface ManagerComponentProps {
    isLoggedIn: boolean;
}

export default function ManagerComponent(props: ManagerComponentProps) {
    const mandant = useSelector((state) => selectMandant(state));

    const renderSidebar = () => {
        if (mandant.abasId == 70447) {
            return <Sidebar70447/>;
        }

        if (import.meta.env.VITE_USE_SIDEBAR_V2) {
            return <SidebarV2/>
        }

        return <Sidebar/>;
    };

    if (!props.isLoggedIn) {
        return <Redirect to={"/login"}/>;
    }
    return (
        <>
            <CssBaseline/>
            <ConfirmProvider
                defaultOptions={{
                    title: null,
                    dialogProps: {
                        maxWidth: "sm",
                        fullWidth: true,
                        style: {
                            zIndex: 100000,
                        },
                    },
                    cancellationText: "Abbrechen",
                    confirmationText: "Bestätigen",
                    cancellationButtonProps: {
                        variant: "outlined",
                        size: "small",
                        color: "secondary",
                        style: {marginBottom: 10},
                        disableElevation: true,
                    },
                    confirmationButtonProps: {
                        variant: "contained",
                        size: "small",
                        style: {marginBottom: 10},
                        disableElevation: true,
                    },
                }}
            >
                {renderSidebar()}
                <ManagerRoutes/>
            </ConfirmProvider>
        </>
    );
}
